// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_analytics.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_analytics.proto.
 */
export const file_plugnmeet_analytics: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message plugnmeet.AnalyticsDataMsg
 */
export type AnalyticsDataMsg = Message<"plugnmeet.AnalyticsDataMsg"> & {
  /**
   * @generated from field: plugnmeet.AnalyticsEventType event_type = 1;
   */
  eventType: AnalyticsEventType;

  /**
   * @generated from field: plugnmeet.AnalyticsEvents event_name = 2;
   */
  eventName: AnalyticsEvents;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;

  /**
   * should be unix milliseconds
   *
   * @generated from field: int64 time = 4 [jstype = JS_STRING];
   */
  time: string;

  /**
   * if we pass value here then it will use redis SET to set the value for the key
   *
   * @generated from field: optional string event_value_string = 5;
   */
  eventValueString?: string | undefined;

  /**
   * if we pass value here then it will use redis INCRBY to increment value for the key
   *
   * @generated from field: optional int64 event_value_integer = 6 [jstype = JS_STRING];
   */
  eventValueInteger?: string | undefined;

  /**
   * if we pass value here then it will use redis HSET to set hash field value for the key
   * hash field will be unix milliseconds, so it will remain unique as always
   *
   * @generated from field: optional string hset_value = 7;
   */
  hsetValue?: string | undefined;

  /**
   * @generated from field: optional string room_sid = 8;
   */
  roomSid?: string | undefined;

  /**
   * @generated from field: optional string user_id = 9;
   */
  userId?: string | undefined;

  /**
   * @generated from field: optional string user_name = 10;
   */
  userName?: string | undefined;

  /**
   * this extra_data can be use for various purposes like, room or user metadata
   *
   * @generated from field: optional string extra_data = 11;
   */
  extraData?: string | undefined;
};

/**
 * Describes the message plugnmeet.AnalyticsDataMsg.
 * Use `create(AnalyticsDataMsgSchema)` to create a new message.
 */
export const AnalyticsDataMsgSchema: GenMessage<AnalyticsDataMsg> = /*@__PURE__*/
  messageDesc(file_plugnmeet_analytics, 0);

/**
 * @generated from message plugnmeet.AnalyticsEventValue
 */
export type AnalyticsEventValue = Message<"plugnmeet.AnalyticsEventValue"> & {
  /**
   * @generated from field: int64 time = 1 [jstype = JS_STRING];
   */
  time: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message plugnmeet.AnalyticsEventValue.
 * Use `create(AnalyticsEventValueSchema)` to create a new message.
 */
export const AnalyticsEventValueSchema: GenMessage<AnalyticsEventValue> = /*@__PURE__*/
  messageDesc(file_plugnmeet_analytics, 1);

/**
 * @generated from message plugnmeet.AnalyticsEventData
 */
export type AnalyticsEventData = Message<"plugnmeet.AnalyticsEventData"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: uint32 total = 2;
   */
  total: number;

  /**
   * @generated from field: repeated plugnmeet.AnalyticsEventValue values = 3;
   */
  values: AnalyticsEventValue[];
};

/**
 * Describes the message plugnmeet.AnalyticsEventData.
 * Use `create(AnalyticsEventDataSchema)` to create a new message.
 */
export const AnalyticsEventDataSchema: GenMessage<AnalyticsEventData> = /*@__PURE__*/
  messageDesc(file_plugnmeet_analytics, 2);

/**
 * @generated from message plugnmeet.AnalyticsRoomInfo
 */
export type AnalyticsRoomInfo = Message<"plugnmeet.AnalyticsRoomInfo"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string room_title = 2;
   */
  roomTitle: string;

  /**
   * @generated from field: int64 room_total_users = 3 [jstype = JS_STRING];
   */
  roomTotalUsers: string;

  /**
   * @generated from field: int64 room_creation = 4 [jstype = JS_STRING];
   */
  roomCreation: string;

  /**
   * @generated from field: int64 room_ended = 5 [jstype = JS_STRING];
   */
  roomEnded: string;

  /**
   * @generated from field: int64 room_duration = 6 [jstype = JS_STRING];
   */
  roomDuration: string;

  /**
   * @generated from field: bool enabled_e2ee = 7;
   */
  enabledE2ee: boolean;

  /**
   * @generated from field: repeated plugnmeet.AnalyticsEventData events = 9;
   */
  events: AnalyticsEventData[];
};

/**
 * Describes the message plugnmeet.AnalyticsRoomInfo.
 * Use `create(AnalyticsRoomInfoSchema)` to create a new message.
 */
export const AnalyticsRoomInfoSchema: GenMessage<AnalyticsRoomInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_analytics, 3);

/**
 * @generated from message plugnmeet.AnalyticsUserInfo
 */
export type AnalyticsUserInfo = Message<"plugnmeet.AnalyticsUserInfo"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool is_admin = 3;
   */
  isAdmin: boolean;

  /**
   * @generated from field: optional string extra_data = 4;
   */
  extraData?: string | undefined;

  /**
   * @generated from field: optional string ex_user_id = 5;
   */
  exUserId?: string | undefined;

  /**
   * @generated from field: repeated plugnmeet.AnalyticsEventData events = 6;
   */
  events: AnalyticsEventData[];
};

/**
 * Describes the message plugnmeet.AnalyticsUserInfo.
 * Use `create(AnalyticsUserInfoSchema)` to create a new message.
 */
export const AnalyticsUserInfoSchema: GenMessage<AnalyticsUserInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_analytics, 4);

/**
 * @generated from message plugnmeet.AnalyticsResult
 */
export type AnalyticsResult = Message<"plugnmeet.AnalyticsResult"> & {
  /**
   * @generated from field: plugnmeet.AnalyticsRoomInfo room = 1;
   */
  room?: AnalyticsRoomInfo | undefined;

  /**
   * @generated from field: repeated plugnmeet.AnalyticsUserInfo users = 2;
   */
  users: AnalyticsUserInfo[];
};

/**
 * Describes the message plugnmeet.AnalyticsResult.
 * Use `create(AnalyticsResultSchema)` to create a new message.
 */
export const AnalyticsResultSchema: GenMessage<AnalyticsResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_analytics, 5);

/**
 * @generated from message plugnmeet.AnalyticsRedisUserInfo
 */
export type AnalyticsRedisUserInfo = Message<"plugnmeet.AnalyticsRedisUserInfo"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string | undefined;

  /**
   * @generated from field: bool is_admin = 2;
   */
  isAdmin: boolean;

  /**
   * @generated from field: optional string extra_data = 3;
   */
  extraData?: string | undefined;

  /**
   * @generated from field: optional string ex_user_id = 4;
   */
  exUserId?: string | undefined;
};

/**
 * Describes the message plugnmeet.AnalyticsRedisUserInfo.
 * Use `create(AnalyticsRedisUserInfoSchema)` to create a new message.
 */
export const AnalyticsRedisUserInfoSchema: GenMessage<AnalyticsRedisUserInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_analytics, 6);

/**
 * @generated from enum plugnmeet.AnalyticsEventType
 */
export enum AnalyticsEventType {
  /**
   * @generated from enum value: ANALYTICS_EVENT_TYPE_ROOM = 0;
   */
  ROOM = 0,

  /**
   * @generated from enum value: ANALYTICS_EVENT_TYPE_USER = 1;
   */
  USER = 1,
}

/**
 * Describes the enum plugnmeet.AnalyticsEventType.
 */
export const AnalyticsEventTypeSchema: GenEnum<AnalyticsEventType> = /*@__PURE__*/
  enumDesc(file_plugnmeet_analytics, 0);

/**
 * @generated from enum plugnmeet.AnalyticsEvents
 */
export enum AnalyticsEvents {
  /**
   * @generated from enum value: ANALYTICS_EVENT_UNKNOWN = 0;
   */
  ANALYTICS_EVENT_UNKNOWN = 0,

  /**
   * room related
   *
   * @generated from enum value: ANALYTICS_EVENT_ROOM_POLL_ADDED = 1;
   */
  ANALYTICS_EVENT_ROOM_POLL_ADDED = 1,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_POLL_ENDED = 2;
   */
  ANALYTICS_EVENT_ROOM_POLL_ENDED = 2,

  /**
   * user join will be room related
   * after take record it will pass to user
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_JOINED = 3;
   */
  ANALYTICS_EVENT_USER_JOINED = 3,

  /**
   * room recorder
   *
   * @generated from enum value: ANALYTICS_EVENT_ROOM_RECORDING_STATUS = 4;
   */
  ANALYTICS_EVENT_ROOM_RECORDING_STATUS = 4,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_RTMP_STATUS = 5;
   */
  ANALYTICS_EVENT_ROOM_RTMP_STATUS = 5,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_BREAKOUT_ROOM = 6;
   */
  ANALYTICS_EVENT_ROOM_BREAKOUT_ROOM = 6,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_ETHERPAD_STATUS = 7;
   */
  ANALYTICS_EVENT_ROOM_ETHERPAD_STATUS = 7,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_EXTERNAL_DISPLAY_LINK_STATUS = 8;
   */
  ANALYTICS_EVENT_ROOM_EXTERNAL_DISPLAY_LINK_STATUS = 8,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_EXTERNAL_MEDIA_PLAYER_STATUS = 9;
   */
  ANALYTICS_EVENT_ROOM_EXTERNAL_MEDIA_PLAYER_STATUS = 9,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_STATUS = 10;
   */
  ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_STATUS = 10,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_TOTAL_USAGE = 11;
   */
  ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_TOTAL_USAGE = 11,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INGRESS_CREATED = 12;
   */
  ANALYTICS_EVENT_ROOM_INGRESS_CREATED = 12,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_WHITEBOARD_FILES = 13;
   */
  ANALYTICS_EVENT_ROOM_WHITEBOARD_FILES = 13,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_TRANSCRIPTION_STATUS = 31;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_TRANSCRIPTION_STATUS = 31,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_TRANSCRIPTION_TOTAL_USAGE = 32;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_TRANSCRIPTION_TOTAL_USAGE = 32,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_SYNTHESIZED_SPEECH_TOTAL_USAGE = 33;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_SYNTHESIZED_SPEECH_TOTAL_USAGE = 33,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_CHAT_TRANSLATION_STATUS = 34;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_CHAT_TRANSLATION_STATUS = 34,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_CHAT_TRANSLATION_TOTAL_USAGE = 35;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_CHAT_TRANSLATION_TOTAL_USAGE = 35,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_AI_TEXT_CHAT_STATUS = 36;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_AI_TEXT_CHAT_STATUS = 36,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_AI_TEXT_CHAT_INTERACTION_TOTAL_USAGE = 37;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_AI_TEXT_CHAT_INTERACTION_TOTAL_USAGE = 37,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_AI_TEXT_CHAT_SUMMARIZATION_TOTAL_USAGE = 38;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_AI_TEXT_CHAT_SUMMARIZATION_TOTAL_USAGE = 38,

  /**
   * @generated from enum value: ANALYTICS_EVENT_ROOM_INSIGHTS_AI_MEETING_SUMMARIZATION_STATUS = 39;
   */
  ANALYTICS_EVENT_ROOM_INSIGHTS_AI_MEETING_SUMMARIZATION_STATUS = 39,

  /**
   * here all related with user
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_LEFT = 14;
   */
  ANALYTICS_EVENT_USER_LEFT = 14,

  /**
   * microphone
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_MIC_STATUS = 15;
   */
  ANALYTICS_EVENT_USER_MIC_STATUS = 15,

  /**
   * @generated from enum value: ANALYTICS_EVENT_USER_TALKED = 16;
   */
  ANALYTICS_EVENT_USER_TALKED = 16,

  /**
   * in milliseconds
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_TALKED_DURATION = 17;
   */
  ANALYTICS_EVENT_USER_TALKED_DURATION = 17,

  /**
   * webcam
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_WEBCAM_STATUS = 18;
   */
  ANALYTICS_EVENT_USER_WEBCAM_STATUS = 18,

  /**
   * screen share
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_SCREEN_SHARE_STATUS = 19;
   */
  ANALYTICS_EVENT_USER_SCREEN_SHARE_STATUS = 19,

  /**
   * polls
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_VOTED_POLL = 20;
   */
  ANALYTICS_EVENT_USER_VOTED_POLL = 20,

  /**
   * chat
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_PUBLIC_CHAT = 21;
   */
  ANALYTICS_EVENT_USER_PUBLIC_CHAT = 21,

  /**
   * @generated from enum value: ANALYTICS_EVENT_USER_PRIVATE_CHAT = 22;
   */
  ANALYTICS_EVENT_USER_PRIVATE_CHAT = 22,

  /**
   * @generated from enum value: ANALYTICS_EVENT_USER_CHAT_FILES = 23;
   */
  ANALYTICS_EVENT_USER_CHAT_FILES = 23,

  /**
   * whiteboard
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_WHITEBOARD_ANNOTATED = 24;
   */
  ANALYTICS_EVENT_USER_WHITEBOARD_ANNOTATED = 24,

  /**
   * @generated from enum value: ANALYTICS_EVENT_USER_WHITEBOARD_FILES = 25;
   */
  ANALYTICS_EVENT_USER_WHITEBOARD_FILES = 25,

  /**
   * speech services
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_SPEECH_SERVICES_USAGE = 26;
   */
  ANALYTICS_EVENT_USER_SPEECH_SERVICES_USAGE = 26,

  /**
   * @generated from enum value: ANALYTICS_EVENT_USER_SPEECH_SERVICES_STATUS = 27;
   */
  ANALYTICS_EVENT_USER_SPEECH_SERVICES_STATUS = 27,

  /**
   * etc
   *
   * @generated from enum value: ANALYTICS_EVENT_USER_INTERFACE_VISIBILITY = 28;
   */
  ANALYTICS_EVENT_USER_INTERFACE_VISIBILITY = 28,

  /**
   * @generated from enum value: ANALYTICS_EVENT_USER_RAISE_HAND = 29;
   */
  ANALYTICS_EVENT_USER_RAISE_HAND = 29,

  /**
   * @generated from enum value: ANALYTICS_EVENT_USER_CONNECTION_QUALITY = 30;
   */
  ANALYTICS_EVENT_USER_CONNECTION_QUALITY = 30,

  /**
   * @generated from enum value: ANALYTICS_EVENT_USER_REACTION = 40;
   */
  ANALYTICS_EVENT_USER_REACTION = 40,
}

/**
 * Describes the enum plugnmeet.AnalyticsEvents.
 */
export const AnalyticsEventsSchema: GenEnum<AnalyticsEvents> = /*@__PURE__*/
  enumDesc(file_plugnmeet_analytics, 1);

/**
 * @generated from enum plugnmeet.AnalyticsStatus
 */
export enum AnalyticsStatus {
  /**
   * @generated from enum value: ANALYTICS_STATUS_STARTED = 0;
   */
  STARTED = 0,

  /**
   * @generated from enum value: ANALYTICS_STATUS_ENDED = 1;
   */
  ENDED = 1,

  /**
   * @generated from enum value: ANALYTICS_STATUS_MUTED = 2;
   */
  MUTED = 2,

  /**
   * @generated from enum value: ANALYTICS_STATUS_UNMUTED = 3;
   */
  UNMUTED = 3,
}

/**
 * Describes the enum plugnmeet.AnalyticsStatus.
 */
export const AnalyticsStatusSchema: GenEnum<AnalyticsStatus> = /*@__PURE__*/
  enumDesc(file_plugnmeet_analytics, 2);

